// extracted by mini-css-extract-plugin
export default {"wrapper":"SidebarLayout_wrapper__L1rp5"};